export const M_LensPanel_HowToReadPrescription = 'M_LensPanel_HowToReadPrescription'
export const D_LensPanel_HowToReadPrescription = 'D_LensPanel_HowToReadPrescription'

export const M_LensPanel_PupillaryDistance = 'M_LensPanel_PupillaryDistance'
export const D_LensPanel_PupillaryDistance = 'D_LensPanel_PupillaryDistance'

export const Eyewear_Protection_Plan = 'Eyewear_Protection_Plan'
